import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Orders, OrdersData } from 'src/app/stores/orders.store';
import { currencyCode, imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-orders-product',
  templateUrl: './orders-product.component.html',
  styleUrls: ['./orders-product.component.scss'],
})
export class OrdersProductComponent implements OnInit {
  @Input() order: OrdersData;
  @Input() isAssign: boolean = false;
  @Input() isConfirm: boolean = false;

  @Input() assignDelivery;
  @Input() confirmDelivery;

  imageUrl = imageUrl;
  currencyCode = currencyCode;
  constructor(public platform: Platform) {}

  ngOnInit() {}
}
